export default function Footer(){
    return(
        <div className="text-center p-6 bg-amber-500">
            <div>© sensemayá, productora de documentales.</div>
            <div className="text-gray-100 font-semibold">www.sensemaya.es / docs@sensemaya.es</div>
        </div>
    )
}